<template>
  <div class="Policy-content-mian" :class="{ 'Policy-content-mian-mobile': isMobile }">
    <PolicyContentItem v-for="item in dataList" :key="item.id" :data="item"></PolicyContentItem>
  </div>
</template>
<script>
  export default {
    name: 'PolicyContent',
    data() {
      return {
        dataList: [
          {
            name: '贝壳隐私政策',
            icon: require('@/assets/images/homePage/privacy-policy.png'),
            id: 1,
            color: 'rgba(2, 115, 245, 1)'
          },
          {
            name: '产品隐私和保护指引',
            icon: require('@/assets/images/homePage/protect-guide.png'),
            id: 2,
            color: 'rgba(65, 200, 161, 1)'
          },
          {
            name: 'SDK隐私政策',
            icon: require('@/assets/images/homePage/SDK.png'),
            id: 3,
            color: 'rgba(255, 195, 91, 1)'
          },
          {
            name: '儿童隐私保护声明',
            icon: require('@/assets/images/homePage/prodect-state.png'),
            id: 4,
            color: 'rgba(62, 174, 208, 1)'
          }
        ]
      };
    }
  };
</script>
<style lang="scss" scoped>
  .Policy-content-mian {
    display: flex;
    margin-top: 0.95rem;
  }
  .Policy-content-mian-mobile {
    flex-wrap: wrap;
    margin-top: 1.33rem;
    padding:0 0.97rem;
    justify-content: space-between;
  }
</style>
